<template>
  <div>
    <v-card outlined class="rounded-lg pa-6">
      <v-row class="mb-4" no-gutters>
        <v-col class="d-flex align-center">
          <span class="text-subtitle-1 font-weight-bold">Estado del proceso</span>
        </v-col>
        <v-col class="d-flex align-center justify-end">
          <v-icon small :color="colorActual" class="mr-1">mdi-check-circle</v-icon>
          <span class="text-body-2 font-weight-medium" :style="{ color: colorActual }">
            (Fase {{ faseActual }} de {{ pasos.length }})
          </span>
        </v-col>
      </v-row>
      <div class="stepper-custom">
        <div class="stepper-custom__linea-base">
          <div class="stepper-custom__linea-progreso"
            :style="{ width: lineaProgresoWidth, backgroundColor: colorActual }"></div>
        </div>
        <div class="stepper-custom__paso" v-for="(paso, index) in pasos" :key="'paso-' + index">
          <div class="stepper-custom__circulo"
            :class="index < faseActual ? 'stepper-custom__circulo--completado' : 'stepper-custom__circulo--pendiente'"
            :style="index < faseActual ? { backgroundColor: colorActual } : null">
            <v-icon v-if="paso.icono.startsWith('mdi-')" :color="index < faseActual ? 'white' : '#B0B0B0'" size="24">
              {{ paso.icono }}
            </v-icon>
            <img v-else :src="paso.icono" width="24" height="24" :alt="paso.label" />
          </div>
          <span class="stepper-custom__label mt-2"
            :class="index < faseActual ? 'stepper-custom__label--completado' : 'stepper-custom__label--pendiente'"
            :style="index < faseActual ? { color: colorActual } : null">
            {{ paso.label }}
          </span>
        </div>
      </div>
    </v-card>

    <div v-if="mensajeEstado" class="banner-estado rounded-lg mt-16 mb-16 pa-4 d-flex"
      :style="{ backgroundColor: mensajeEstado.bgColor, borderColor: mensajeEstado.color }">
      <v-icon :color="mensajeEstado.color" class="mr-2 mb-14">mdi-information-outline</v-icon>
      <div>
        <span class="d-block font-weight-bold mt-1 estadoTitulo" :style="{ color: mensajeEstado.color }">
          {{ mensajeEstado.titulo }}
        </span>
        <span class="estadoTexto" :style="{ color: mensajeEstado.color }">{{ mensajeEstado.texto }}</span>
      </div>
    </div>
  </div>
</template>

<script>
const ESTADO_A_FASE = {
  Postulado: 1,
  Evaluación: 2,
  Finalizado: 3,
};

const COLOR_HEX = {
  verde: "#16A34A",
  amarillo: "#F3A723",
  rojo: "#DC2626",
};

export default {
  name: "EstadoProcesoStepper",
  props: {
    estado: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pasos: [
        { label: "Postulado", icono: "mdi-file-document-outline" },
        { label: "Evaluación", icono: "/img/content_paste_search.svg" },
        { label: "Finalizado", icono: "mdi-check-underline" },
      ],
    };
  },
  computed: {
    faseActual() {
      return ESTADO_A_FASE[this.estado] || 1;
    },
    colorActual() {
      return COLOR_HEX[this.color] || COLOR_HEX.verde;
    },
    lineaProgresoWidth() {
      return ((this.faseActual - 1) / (this.pasos.length - 1)) * 100 + "%";
    },
    mensajeEstado() {
      if (this.estado === "Postulado" && this.color === "verde") {
        return {
          color: "#1C1E4D",
          bgColor: "#EBEFFB",
          titulo: "¡Su postulación ha sido recibida con éxito!",
          texto:
            "Usted ha sido postulado a esta oferta laboral y actualmente se encuentra en proceso de selección. Le recomendamos mantenerse pendiente de su correo electrónico y del número de teléfono registrado, ya que por estos medios se le notificará cualquier actualización sobre el proceso de selección.",
        };
      }
      if (this.estado === "Postulado" && this.color === "rojo") {
        // TODO: texto de relleno, pendiente de definir el mensaje real
        return {
          color: "#93000A",
          bgColor: "#FFDAD6",
          titulo: "Su postulación no pudo continuar",
          texto:
            "Lamentablemente su postulación no cumplió con los requisitos para continuar en este proceso de selección. Agradecemos su interés y le invitamos a participar en futuras convocatorias que se ajusten a su perfil.",
        };
      }
      if (this.estado === "Evaluación" && this.color === "rojo") {
        return {
          color: "#93000A",
          bgColor: "#FFDAD6",
          titulo: "Gracias por participar en este proceso de selección",
          texto:
            "Su participación en esta oferta laboral ha finalizado debido a que no obtuvo el resultado requerido en una de las evaluaciones. Agradecemos su interés y el tiempo dedicado durante el proceso. Lo invitamos a continuar consultando las ofertas disponibles y participar en futuras convocatorias que se ajusten a su perfil.",
        };
      }
      if (this.estado === "Finalizado" && this.color === "verde") {
        return {
          color: "#166534",
          bgColor: "#EAFAF0",
          titulo: "¡Su proceso de postulación ha finalizado!",
          texto:
            "Su postulación ha sido completada correctamente y actualmente se encuentra en proceso de selección. Le recomendamos mantenerse pendiente de su correo electrónico y del número de teléfono registrados, ya que por estos medios nos comunicaremos con usted para informarle sobre cualquier novedad o el resultado del proceso de selección.",
        };
      }
      return null;
    },
  },
};
</script>

<style scoped>
.stepper-custom {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  padding: 16px 0 8px;
}

.stepper-custom__linea-base {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #D3D3D3;
  border-radius: 2px;
}

.stepper-custom__linea-progreso {
  height: 100%;
  background-color: #16A34A;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.stepper-custom__paso {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 80px;
  position: relative;
  z-index: 1;
}

.stepper-custom__circulo {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.stepper-custom__circulo--completado {
  background-color: #16A34A;
}

.stepper-custom__circulo--pendiente {
  background-color: white;
  border: 2px solid #D3D3D3;
}

.stepper-custom__label {
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
}

.stepper-custom__label--completado {
  color: #16A34A;
  font-weight: 600;
}

.stepper-custom__label--pendiente {
  color: #B0B0B0;
  font-weight: 400;
}

.banner-estado {
  border-left: 4px solid;
  font-size: 14px;
  line-height: 1.4;
}

.estadoTitulo {
  line-height: 28px;
  font-weight: 600;
  font-size: 18px;
}

.estadoTexto {
  line-height: 26px;
  font-weight: 400;
  font-size: 16px;
}
</style>
